import React, { useState } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import Form from "react-bootstrap/Form";
import MedicalPillButton from "./MedicalPillButton";
import doubleImage from "../../images/double-vision.jpg";
import wordMovingImage from "../../images/words-moving.jpg";

const MedicalListSelector = ({
  addSymptoms,
  patient,
  category,
  list,
  maxSelectAmount,
  selectedList,
  toggleFromSelectedList,
  selectOne,
  addOther,
  index,
  noOther,
  noSuffix,
  setHeadacheParts,
  headacheParts,
  message,
  translationNamespace,
}) => {
  const { t } = useTranslation();
  const tItem = (cat, factor) => {
    const ns = translationNamespace || "symptom";
    // normalize category for trigger keys (e.g. "screen time" -> "screen_time")
    const normCat = cat.toLowerCase().replace(/ /g,"_");
    const safe = factor.trim().toLowerCase()
      .replace(/ /g,"_").replace(/\//g,"_").replace(/,/g,"")
      .replace(/:/g,"").replace(/'/g,"").replace(/[()]/g,"").replace(/-/g,"_")
      .substring(0, 60);
    const key = `${ns}.${normCat}.${safe}`;
    const translated = t(key);
    return translated !== key ? translated : factor;
  };
  const [newItem, setNewItem] = useState("");
  const [showDoubleVision, setShowDoubleVision] = useState(false);
  const [showWordMoving, setShowWordMoving] = useState(false);
  const naItems = ["N/A", "n/a", "NA", "na"];

  let suffix;
  if (!noSuffix) {
    if (!maxSelectAmount) {
      suffix = ` (${t("medicalistelector.choose_all")}) `;
    } else {
      suffix = ` (${t("medicalistelector.choose")} ${maxSelectAmount}) `;
    }
  }

  if (list.includes("Menstrual Cycle") && patient?.gender == "male") {
    list = list.filter((item) => item !== "Menstrual Cycle");
  }

  const colors = {
    cognitive: "#dab7ec", sleep: "#ffdadb", physical: "#ffdcaf",
    emotional: "#fff3c4", speech: "#cef3c4", vision: "#c1fdf7",
    wellness: "#dab7ec", travel: "#ffdadb", "screen time": "#ffdcaf",
    environmental: "#fff3c4", Dietary: "#cef3c4", situational: "#c1fdf7",
    Alternative: "#dab7ec", Applied: "#ffdadb", Chiropractic: "#ffdcaf",
    Vision: "#fff3c4", "Mental Health": "#c1fdf7", Other: "#f4f3ee",
  };

  const handleChange = (event) => setNewItem(event.target.value);

  const handleKeyPress = (event) => {
    if (
      event.key === "Enter" ||
      (!event.currentTarget.contains(document.activeElement) &&
        newItem !== "" &&
        !naItems.includes(newItem))
    ) {
      const formattedItem = addOther(newItem, index);
      if (maxSelectAmount === 1) {
        selectOne(formattedItem, category);
      } else {
        toggleFromSelectedList(formattedItem, selectedList, category, maxSelectAmount);
      }
      setNewItem("");
    }
  };

  const toggleHelpImg = (item, status) => {
    const helpImgItems = ["Double vision", "Words move when reading"];
    if (helpImgItems.includes(item)) {
      if (item === helpImgItems[0] && status === "enter") {
        setShowDoubleVision(true);
      } else if (item === helpImgItems[1] && status === "enter") {
        setShowWordMoving(true);
      } else {
        setShowDoubleVision(false);
        setShowWordMoving(false);
      }
    }
  };

  const onChange = (e) => {
    let newValue = e.target.value;
    if (e.target.checked && !headacheParts.includes(newValue)) {
      setHeadacheParts((selectedList) => [...selectedList, newValue]);
    } else if (!e.target.checked) {
      setHeadacheParts(headacheParts.filter((item) => item !== newValue));
    }
  };

  const style =
    addSymptoms == true
      ? { color: "black", border: " white", textAlign: "left", fontWeight: "normal", fontSize: "15px" }
      : { color: "black", border: " white", textAlign: "left" };

  // canonical English key for headache check
  const headacheKey = "Headaches caused by close work: computers, reading, gaming";

  return (
    <div className="listSelector" style={{ height: "30rem", overflow: "scroll", fontWeight: "normal", fontSize: "15px" }}>
      <div className="mb-2">
        <h6 className="d-inline">{message}</h6>
        <em className="d-inline">{suffix}</em>
      </div>

      {list?.map((selectableItem) => (
        <span key={selectableItem + 0}>
          <MedicalPillButton
            onClick={() =>
              maxSelectAmount === 1
                ? selectOne(selectableItem, category)
                : toggleFromSelectedList(selectableItem, selectedList, category, maxSelectAmount)
            }
            onMouseOver={() => toggleHelpImg(selectableItem, "enter")}
            onMouseOut={() => toggleHelpImg(selectableItem, "leave")}
            variant={"light"}
            key={selectableItem}
            style={style}
          >
            {selectedList.includes(selectableItem) ? (
              <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                <title>icon/action/check_ccircle_24px</title>
                <defs>
                  <path d="M12,2 C6.48,2 2,6.48 2,12 C2,17.52 6.48,22 12,22 C17.52,22 22,17.52 22,12 C22,6.48 17.52,2 12,2 Z M10,17 L5,12 L6.41,10.59 L10,14.17 L17.59,6.58 L19,8 L10,17 Z" id="path-1"></path>
                </defs>
                <g id="icon/action/check_ccircle_24px" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <mask id="mask-2" fill="white"><use xlinkHref="#path-1"></use></mask>
                  <use id="-↳Color" fill={colors[category]} xlinkHref="#path-1"></use>
                </g>
              </svg>
            ) : (
              <svg width="24px" height="24px" viewBox="0 0 22 22">
                <circle cx="11" cy="11" r="9.5" stroke="grey" strokeWidth="1" fill="white" />
              </svg>
            )}{" "}
            {tItem(category, selectableItem)}
          </MedicalPillButton>
          {selectableItem === "Double vision" && showDoubleVision ? (
            <img className="helpImage" alt="double vision image" src={doubleImage} key={selectableItem + 1} />
          ) : null}
          {selectableItem === "Words move when reading" && showWordMoving ? (
            <img className="helpImage" alt="word moving image" src={wordMovingImage} key={selectableItem + 2} />
          ) : null}
        </span>
      ))}

      {selectedList.includes(headacheKey) && headacheParts ? (
        <>
          <Form className="headacheForm">
            <label className="w-100">{t("medicalistelector.headache_location.label")}</label>
            {[
              { label: t("medicalistelector.headache_location.fore"), value: "Fore" },
              { label: t("medicalistelector.headache_location.backtop"), value: "BackTop" },
              { label: t("medicalistelector.headache_location.right"), value: "Right" },
              { label: t("medicalistelector.headache_location.left"), value: "Left" },
              { label: t("medicalistelector.headache_location.behind"), value: "Behind" },
              { label: t("medicalistelector.headache_location.eyes"), value: "Eyes" },
              { label: t("medicalistelector.headache_location.backbottom"), value: "BackBottom" },
              { label: t("medicalistelector.headache_location.all"), value: "All" },
            ].map((location, i) => (
              <Form.Check
                inline
                label={location.label}
                value={location.value}
                type="checkbox"
                name="headachePart"
                key={i}
                onChange={onChange}
                checked={headacheParts.includes(location.value) ? true : false}
              />
            ))}
          </Form>
          <hr></hr>
          <br></br>
        </>
      ) : null}

      {noOther ? "" : (
        <label htmlFor={`${category}-other`} className="w-100">
          {t("medicalistelector.other")}: &nbsp;
          <input
            value={newItem}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            onBlur={handleKeyPress}
            aria-label="Type the name of a new item and press enter to add a button to the list above"
            id={`${category}-other`}
            style={{
              border: "0", outline: "0", background: "transparent",
              borderBottom: "2px solid black", width: "33%",
            }}
            name="other"
            placeholder={t("medicalistelector.other")}
          />
        </label>
      )}
    </div>
  );
};

export default MedicalListSelector;